module.exports = __webpack_public_path__ + "public/SiteIcons/listArrowLeft.svg?6de5fd99";